/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerStorePdfSettingsMutationRequest, FilesControllerStorePdfSettingsMutationResponse, FilesControllerStorePdfSettingsPathParams, FilesControllerStorePdfSettingsQueryParams } from "../../models/filesController/FilesControllerStorePdfSettings";

function getFilesControllerStorePdfSettingsUrl(id: FilesControllerStorePdfSettingsPathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/files/${id}/pdf-settings` as const }  
  return res
}

/**
 * @description Stores PDF generation settings in Redis cache and returns a settings key. The key can be used to retrieve settings for SSR rendering or browser preview. Settings expire after 15 minutes by default (max 1 hour).
 * @summary Store PDF generation settings
 * {@link /api/v1/files/:id/pdf-settings}
 */
export async function filesControllerStorePdfSettings(id: FilesControllerStorePdfSettingsPathParams["id"], data?: FilesControllerStorePdfSettingsMutationRequest, params?: FilesControllerStorePdfSettingsQueryParams, config: Partial<RequestConfig<FilesControllerStorePdfSettingsMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<FilesControllerStorePdfSettingsMutationResponse, ResponseErrorConfig<Error>, FilesControllerStorePdfSettingsMutationRequest>({ method : "POST", url : getFilesControllerStorePdfSettingsUrl(id).url.toString(), params, data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}